export default __webpack_public_path__ + "static/media/kid-play.668ab328.png";